export function validateDate(d) {
  if (Object.prototype.toString.call(d) === "[object Date]") {
    if (isNaN(d.getTime())) {
      return undefined
    } else {
      return d
    }
  } else {
    return undefined
  }
}

export function isToday(date) {
  if (date) {
    if (date instanceof Date) {
      return date.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
    } else {
      return (
        new Date(date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
      )
    }
  } else {
    return null
  }
}

export function decimalToHour(value) {
  const minutes = 60 * (value % 1)
  const hours = Math.trunc(value)
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
}

export function readableHour(value) {
  if (value || value === 0) {
    if (value >= 1 && value < 12) {
      return `${decimalToHour(value)} AM`
    } else if (value >= 12 && value < 24) {
      return `${decimalToHour(value === 12 ? value : value - 12)} PM`
    } else {
      return `${decimalToHour(value - 12)} AM`
    }
  }
}
